import {
  type PasteTarget,
  thunkPasteFromClipboard,
} from '@store/migrationActions/thunkActions/thunkClipboardActions'
import type { AppState } from '@store/types'
import {
  ErrorNotification,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

const CLIPBOARD_UNAVAILABLE_TEXT =
  'Clipboard is unavailable. Allow clipboard access in the site settings.'

const NOTHING_TO_PASTE_TEXT = 'Nothing to paste here'

// Paste item of a toolbar menu. The clipboard is read on click, not when the
// menu opens: readText needs a user gesture, so the item cannot know ahead
// whether the clipboard holds anything for it and reports that with a toast.
// `pasting` is on while the clipboard is read and the paste is applied: the
// menu closes on the click, so the More button shows the loader meanwhile.
export const usePasteFromToolbar = (target: PasteTarget) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()
  const [pasting, setPasting] = useState(false)

  const onPaste = async () => {
    setPasting(true)

    try {
      const result = await dispatch(thunkPasteFromClipboard(target))

      if (result === 'CLIPBOARD_UNAVAILABLE') {
        dispatch(ErrorNotification(CLIPBOARD_UNAVAILABLE_TEXT))
      }

      if (result === 'NOTHING_TO_PASTE') {
        dispatch(
          notificationActionCreators.setCustomNotification({
            type: 'gray',
            text: NOTHING_TO_PASTE_TEXT,
            toastContainerId: 'secondary',
          })
        )
      }
    } finally {
      setPasting(false)
    }
  }

  return { onPaste, pasting }
}
